export const GRID_SIZE = 20;
export const CANVAS_SIZE = 400;
export const TILE_COUNT = CANVAS_SIZE / GRID_SIZE;
export const MOVE_INTERVAL = 150; // Snake move speed in ms

export const WARP_RADIUS_TILES = 12;
export const WARP_MAX_PULL_PIXELS = 0.8 * GRID_SIZE;
export const EXTENDED_GRID_TILES = 5;
